/** Frontend model for one referral partner row, with parsed dates. */
export interface ReferralPartner {
  id: string;
  name: string;
  email: string;
  code: string;
  notes: string | null;
  acceptanceToken: string;
  termsVersion: string | null;
  termsAcceptedAt: Date | null;
  dateCreated: Date;
  referralCount: number;
  convertedCount: number;
  unpaidAmountMinorUnits: number;
  paidAmountMinorUnits: number;
  bountyCurrency: string;
}

/** The partner's share link — what they put in posts and messages. */
export const referralShareLink = (partner: ReferralPartner): string =>
  `${window.location.origin}/?ref=${partner.code}`;

/** The tokenized terms-acceptance link the admin sends the partner. */
export const partnerTermsLink = (partner: ReferralPartner): string =>
  `${window.location.origin}/partner/terms/${partner.acceptanceToken}`;
